/**
 * 화면 구현
 */
import { SbsPlayerGlobal } from '../../common';

customElements.define(
  'sbs-player-member-need-auth',
  class extends HTMLElement {
    constructor() {
      super();
      this.visible = false;
    }

    set visible(value) {
      this._visible = value;
      this.render();
    }

    get visible() {
      return this._visible;
    }

    static get observedAttributes() {
      return [];
    }

    async attributeChangedCallback(name, oldValue, newValue) {
      try {
      } catch (error) {
        console.log(error);
      }
    }

    async connectedCallback() {
      try {
        this.render();
      } catch (error) {
        console.log(error);
      }
    }

    disconnectedCallback() {
      try {
      } catch (error) {
        console.log(error);
      }
    }

    adoptedCallback() {
      try {
      } catch (error) {
        console.log(error);
      }
    }

    render() {
      try {
        const { info } = SbsPlayerGlobal.state.data;

        // ! 하드코딩으로 결정
        this.innerHTML = `<div class="playerDialogMembership_w current" role="dialog" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;">
        <div style="
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          width: 100%;
          height: 100%;
          background: url(${
            info?.defaultimage || info?.thumbimg || info?.program_image
          }) no-repeat center center;
          background-size: cover;
          opacity: 0.6;
          z-index: -1;
        "></div>
        <div class="playerDialogContents">
          <div class="playerDialogTop">
            <p class="playerDialogTop-text"><strong class="txt01">본인 인증 후 서비스 이용이 가능합니다.</strong></p>
          </div>
          <div class="playerLiveBtns_w">
            <a href="javascript:void(0);" class="btn_bgGra">본인 인증 하기</a>
          </div>
        </div>
      </div>`;
        this.styles();
        this.event();
      } catch (error) {
        console.log(error);
      }
    }

    styles() {
      try {
        // .playerWrap이 position: relative인지 확인하고 필요시 설정
        const playerWrap = document.querySelector('.playerWrap');
        if (playerWrap && getComputedStyle(playerWrap).position === 'static') {
          playerWrap.style.position = 'relative';
        }
      } catch (error) {
        console.log(error);
      }
    }

    event() {
      try {
        const linkElement = this.querySelectorAll('a[class^="btn_bgGra"]');
        for (let i = 0; i < linkElement.length; i++) {
          linkElement[i].addEventListener('click', (e) => {
            // ! 25-10-29 본창으로 이동
            if (SbsPlayerGlobal.development) {
              window.location.href = `https://join.developers.sbs.co.kr/merge/verify.do?returnUrl=${encodeURIComponent(
                window.location.href
              )}`;
            } else {
              window.location.href = `https://join.sbs.co.kr/merge/verify.do?returnUrl=${encodeURIComponent(
                window.location.href
              )}`;
            }
          });
        }

        this.querySelector('.playerDialogMembership_w').classList.add(
          'current'
        );
      } catch (error) {
        console.log(error);
      }
    }
  }
);
